import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileLock"><Path d="M3.5 16.5H10.5V21.5H3.5V16.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M4.5 16C4.5 14.6193 5.61929 13.5 7 13.5C8.38071 13.5 9.5 14.6193 9.5 16V16.5H4.5V16Z" stroke="currentColor" strokeLinecap="round"/><Path d="M4.5 11V2.5H13L19.5 9V21.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFileLock;
